'use client'

import FullscreenButton from '@/app/[locale]/[roomId]/components/FullscreenButton'
import GithubButton from '@/app/[locale]/[roomId]/components/GithubButton'
import LikeButton from '@/app/[locale]/[roomId]/components/LikeButton'
import SharePopoverButton from '@/app/[locale]/[roomId]/components/SharePopoverButton'
import WorldMoreActionButton from '@/app/[locale]/[roomId]/components/WorldMoreActionButton'
import WorldReportModal from '@/app/[locale]/[roomId]/components/WorldReportModal'
import ReportConfirmationModal from '@/components/ReportConfirmationModal'
import { useUAContext } from '@/context/UAContext'
import { useWorldDetailsContext } from '@/context/WorldDetailsContext'
import { cn } from '@/lib/utils'
import { useState } from 'react'
import { useIsClient } from 'usehooks-ts'

export default function WorldActionButtons({ className }: { className?: string }) {
  const { isMobile } = useUAContext()
  const { worldMeta } = useWorldDetailsContext()
  const isClient = useIsClient()
  const [isReportModalOpen, setIsReportModalOpen] = useState(false)
  const [isReportSuccessOpen, setIsReportSuccessOpen] = useState(false)

  return (
    <div className={cn('flex flex-shrink-0 flex-col items-end gap-2', className)}>
      <div className="flex gap-2">
        <LikeButton className="p-[7px]" iconClassName="size-4.5" />
        <SharePopoverButton className="p-[7px]" iconClassName="size-4.5" />
        {isClient && !isMobile && <GithubButton className="p-[7px]" iconClassName="size-4.5" />}
        {isClient && !isMobile && worldMeta?.scene_type === 'standalone' && (
          <FullscreenButton className="p-[7px]" iconClassName="size-4.5" />
        )}
        <WorldMoreActionButton handleReport={() => setIsReportModalOpen(true)} />
        <WorldReportModal
          isDialogOpen={isReportModalOpen}
          onClose={() => setIsReportModalOpen(false)}
          onReportSuccess={() => setIsReportSuccessOpen(true)}
        />
        <ReportConfirmationModal
          open={isReportSuccessOpen}
          onAction={() => setIsReportSuccessOpen(false)}
        />
      </div>
    </div>
  )
}
